import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Helmet } from "react-helmet";
import { APP_VERSION, LAST_UPDATE_DATE } from "../siteDefaults/config";

const HomePage = () => {
    const details = ["RASH TRADE SOLUTION", `VERSION ${APP_VERSION} `, `${LAST_UPDATE_DATE}`];

    return (
        <div className="flex flex-col justify-center items-center text-4xl lg:text-7xl bg-secondaryGreen w-full">
            {details.map((detail, index) => {
                return (
                    <div
                        key={index}
                        className="mt-4 flex  justify-center items-center w-full text-center">
                        {detail}
                    </div>
                );
            })}
            <Helmet>
                <meta charSet="utf-8" />
                <title>Home Page</title>
            </Helmet>
        </div>
    );
};

export default HomePage;
